import { IconChevronDown } from './Down';
import { IconChevronDownLarge } from './DownLarge';
import { IconChevronLeft } from './Left';
import { IconChevronRight } from './Right';
import { IconChevronRightLarge } from './RightLarge';
import { IconChevronUp } from './Up';
import { IconChevronUpLarge } from './UpLarge';
import { IconChevronUpDown } from './UpDown';
export const IconChevron = {
    ChevronDown: IconChevronDown,
    ChevronDownLarge: IconChevronDownLarge,
    ChevronLeft: IconChevronLeft,
    ChevronRight: IconChevronRight,
    ChevronRightLarge: IconChevronRightLarge,
    ChevronUp: IconChevronUp,
    ChevronUpLarge: IconChevronUpLarge,
    ChevronUpDown: IconChevronUpDown,
};
//# sourceMappingURL=index.js.map